<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Employee Messages</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="newMessage = true"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="employeeMessageList"
		[loading]="!employeeMessageList"
		[globalFilterFields]="app.keys(employeeMessageList)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="p-grid">
				<div class="p-col-12 p-md-9 py-3">
					<span class="p-float-label p-input-icon-left w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
				<div class="p-col-12 p-md-3">
					<span class="p-float-label">
						<p-dropdown
							#employeeSelectDrop
							[options]="employeeList"
							optionLabel="NickName"
							name="employeeSelectDrop"
							[(ngModel)]="employeeRecordSelected"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							(filterBy)="app.keys(employeeList)"
							(onChange)="employeeSelect(+employeeRecordSelected.ID)"
						></p-dropdown>
						<label for="employeeSelectDrop">Employee</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="created">
					Created
					<p-sortIcon field="created"></p-sortIcon>
				</th>
				<th pSortableColumn="subject">
					Subject
					<p-sortIcon field="subject"></p-sortIcon>
				</th>
				<th pSortableColumn="notificationType">
					Sent By
					<p-sortIcon field="notificationType"></p-sortIcon>
				</th>
				<th pSortableColumn="sentDateTime">
					Sent Date
					<p-sortIcon field="sentDateTime"></p-sortIcon>
				</th>
				<th pSortableColumn="readDateTime">
					Read Date
					<p-sortIcon field="sentDateTime"></p-sortIcon>
				</th>
				<th pSortableColumn="authorUserKey">
					Author
					<p-sortIcon field="authorUserKey"></p-sortIcon>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td (click)="employeeMessageSelected = rec">
					<span class="p-column-title">Created</span>
					{{ moment(rec.created).format("l LT") }}
				</td>
				<td (click)="employeeMessageSelected = rec">
					<span class="p-column-title">Subject</span>
					{{ rec.subject }}
				</td>
				<td (click)="employeeMessageSelected = rec">
					<span class="p-column-title">Sent By</span>
					<fa-icon [icon]="['far', 'at']" size="lg" *ngIf="rec.notificationType === 1"></fa-icon>
					<fa-icon [icon]="['far', 'sms']" size="lg" *ngIf="rec.notificationType === 2"></fa-icon>
					<fa-icon [icon]="['far', 'cash-register']" size="lg" *ngIf="rec.notificationType === 3"></fa-icon>
					<fa-icon [icon]="['far', 'browser']" size="lg" *ngIf="rec.notificationType === 4"></fa-icon>
					<fa-icon [icon]="['far', 'mobile']" size="lg" *ngIf="rec.notificationType === 5"></fa-icon>
				</td>
				<td (click)="employeeMessageSelected = rec">
					<span class="p-column-title">Sent Date</span>
					{{ moment(rec.sentDateTime).format("l LT") }}
				</td>
				<td (click)="employeeMessageSelected = rec">
					<span class="p-column-title">Read Date</span>
					<span *ngIf="rec.readDateTime">
						{{ moment(rec.readDateTime).format("l LT") }}
					</span>
					<fa-icon [icon]="['far', 'envelope']" size="lg" *ngIf="!rec.readDateTime"></fa-icon>
				</td>
				<td (click)="employeeMessageSelected = rec">
					<span class="p-column-title">Author</span>
					<div class="d-flex">
						{{ rec.authorUser.firstName }} {{ rec.authorUser.lastName }}
						<p-button
							pRipple
							styleClass="p-button-raised p-button-danger m-2"
							[disabled]="rec.notificationType === 1 || rec.notificationType === 2 || rec.notificationType === 5 || rec.readDateTime"
							(click)="deleteMessage(rec.pk, rec.sk)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
							</ng-template>
						</p-button>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-employee-message-new-record
	*ngIf="newMessage"
	[employeeList]="employeeList"
	(clearEmitter)="newMessage = !$event"
	(sentMessagePayload)="returnFromNewEmployeeMessage($event)"
></app-employee-message-new-record>

<p-dialog
	*ngIf="employeeMessageSelected"
	[(visible)]="employeeMessageSelected"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
	[closable]="true"
>
	<ng-template pTemplate="header">
		<div class="d-flex h3">
			Employee Messsage to {{ employeeMessageSelected.notificationAddress }} on {{ moment(employeeMessageSelected.sentDateTime).format("l LT") }}
		</div>
	</ng-template>
	<div class="d-flex">
		<div class="m-2 flex-fill">
			<div class="p-grid">
				<div class="p-col">Sent</div>
				<div class="p-col">
					{{ moment(employeeMessageSelected.sentDateTime).format("l LT") }}
				</div>
			</div>
		</div>
		<div class="m-2 flex-fill">
			<div class="p-grid">
				<div class="p-col">Read</div>
				<div class="p-col">
					<span *ngIf="employeeMessageSelected.readDateTime">{{ moment(employeeMessageSelected.readDateTime).format("l LT") }}</span>
					<span *ngIf="!employeeMessageSelected.readDateTime">Unread</span>
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex">
		<div class="m-2 h4">sent by</div>
	</div>
	<div class="d-flex">
		<div class="my-2 ms-4 me-2">{{ employeeMessageSelected.authorUser.firstName }} {{ employeeMessageSelected.authorUser.lastName }}</div>
	</div>
	<div class="d-flex">
		<div class="m-2 h4">subject</div>
	</div>
	<div class="d-flex">
		<div class="my-2 ms-4 me-2">
			{{ employeeMessageSelected.subject }}
		</div>
	</div>
	<div class="d-flex">
		<div class="m-2 h4">message</div>
	</div>
	<div class="d-flex">
		<div class="my-2 ms-4 me-2">
			{{ employeeMessageSelected.body }}
		</div>
	</div>
</p-dialog>
